let countFormat: Intl.NumberFormat | undefined;

/** A count with thousands separators: "1,204". */
export function formatCount(value: number | bigint): string {
  countFormat ??= new Intl.NumberFormat('en-US');
  return countFormat.format(value);
}

/**
 * A count with its noun, plural when it is not one: "1 investor",
 * "1,204 investors". For nouns whose plural adds an "s".
 */
export function formatCountOf(value: number, noun: string): string {
  return `${formatCount(value)} ${noun}${value === 1 ? '' : 's'}`;
}
